import http from "./http";

/**
 * Service for advancing a pedido one estado forward via the generic
 * confirmation endpoint (used across the app: AdminVentas.vue "Confirmar",
 * Deposito.vue's per-row confirm, and now the "Gestión de pedidos" board's
 * drag-and-drop). The backend decides the next id_estado from
 * id_estatus_pedido (the CURRENT one) + envio.
 *
 * id_rol is intentionally omitted: AdminVentas.vue's confirmarPedido()
 * already does this with a comment noting the controller doesn't need it.
 */
const PedidosValidarService = {
  /**
   * @param {{id_pedido: number, id_estatus_pedido: number, envio?: number}} payload
   * @returns {Promise} Axios response; response.data = { error, mensaje, productos? }
   */
  validar(payload) {
    return http.put("pedidos/validar", payload);
  },
};

export default PedidosValidarService;
